function isExternalRoute(route: string): boolean {
  return /^https?:\/\//.test(route);
}

function getRedirectToUrl(
  defaultRedirectTo: string,
  redirectToParam: string | null,
) : string {
  let redirectTo = defaultRedirectTo;

  if (redirectToParam) {
    try {
      redirectTo = decodeURIComponent(redirectToParam);
    } catch (e) {
      /**
       * Technically nothing to do, the default redirectTo value will be picked up
       * But we could fail decoding a malformed Url, which requires catching.
       */
    }
  }

  return redirectTo;
}

export {
  isExternalRoute,
  getRedirectToUrl,
};
